$(function () {
    $('.dataTable').DataTable({
        paging: false,
        searching: true,
        ordering: true,
        info: false,
        order: [[1, 'asc']],
        columnDefs: [
            {
                orderable: false,
                targets: 0
            }
        ],
        responsive: {
            details: {
                display: $.fn.dataTable.Responsive.display.childRowImmediate,
                type: ''
            }
        },
        language: {
            search: "_INPUT_",
            searchPlaceholder: "Search..."
        }
    });
});
